import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle } from "../shadcn/ui/dialog";
import { Button } from "../shadcn/ui/button";

const HReusableAlertModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  confirmVariant = "primary", // 'primary' (indigo) or 'destructive' (red)
  isLoading = false,
  loadingLabel = "Processing...",
}) => {
  const isDestructive = confirmVariant === "destructive";

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="pt-1 pb-2">
          <p className="text-sm text-gray-600">{description}</p>
        </div>
        <DialogFooter className="flex justify-end space-x-3">
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            className={`${isDestructive ? "bg-red-600 hover:bg-red-700" : "bg-[#3A36DB] hover:bg-[#2d2bb8]"} text-white`}
          >
            {isLoading ? loadingLabel : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default HReusableAlertModal;
